import SnapshotsSerializer from './base';

export default class SnapshotSet extends SnapshotsSerializer {
  normalize(modelClass, payload) {
    let defaults = {
      numSnapshotsWithoutPdf: 0,
    };
    Object.assign(defaults, payload);
    Object.assign(payload, defaults);

    return super.normalize(...arguments);
  }
}
